// TODO: For some reason `data-focus-visible` attribute gets added when clicked on the switch initially. In Chakra docs it doesn't happen. Needs to be investigated.
export const Switch = {
  baseStyle: {
    track: {
      bg: 'product.icon',
      _checked: {
        bg: 'product.secondary',
      },
    },
  },
  variants: {
    striking: {
      track: {
        bg: 'product.icon',
        _checked: {
          bg: 'product.secondary',
        },
      },
    },
  },
}
